import React, { useEffect, useState } from 'react'
import { CCardText, CRow, CCol, CFormCheck, CButton, CFormTextarea, CFormSelect, CFormInput, CModal, CModalBody, CModalHeader, CModalFooter, CModalTitle } from '@coreui/react';
import CookieFunctions from '../../functions/CookieFunctions';
import { toast } from 'react-toastify';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import '../../styles/TimeOff.css';

import { timeOffNames } from '../../Constants';

export default function CreateRequestModal({ visible, closeModal, driver, getRequests }) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [halfDay, setHalfDay] = useState(false);
    const [comments, setComments] = useState("");
    const [errors, setErrors] = useState([])
    const [weekend, setWeekend] = useState(false);
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState("");
    const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);
    const [requestData, setRequestData] = useState(null);


    const [type, setType] = useState(Object.keys(timeOffNames[driver[0].driver_type][driver[0].country])[0]);

    function onSubmit() {
        setLoading(true)
        setErrors([])

        var valid = validateData()

        if (valid.length !== 0) {
            setErrors(valid)
            setLoading(false)
            return
        }

        var newStartDate = startDate;
        var newEndDate = endDate;

        if (halfDay) {
            newStartDate = addTime(startDate, document.getElementById("startTime").value)
            newEndDate = addTime(startDate, document.getElementById("endTime").value)
        }

        var newStartDateString = (newStartDate.getMonth() + 1) + "/" + newStartDate.getDate() + "/" + newStartDate.getFullYear() + " " + newStartDate.getHours() + ":" + newStartDate.getMinutes() + ":" + newStartDate.getSeconds();
        var newEndDateString = (newEndDate.getMonth() + 1) + "/" + newEndDate.getDate() + "/" + newEndDate.getFullYear() + " " + newEndDate.getHours() + ":" + newEndDate.getMinutes() + ":" + newEndDate.getSeconds();

        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();

        formData.append("timeOffType", type)
        formData.append("startDate", newStartDateString)
        formData.append("endDate", newEndDateString)
        formData.append("halfDay", halfDay)
        formData.append("comments", comments)
        formData.append("driverId", driver[0].mpp_id)
        formData.append("firstName", driver[0].mpp_firstname)
        formData.append("lastName", driver[0].mpp_lastname)
        formData.append("driverType", driver[0].driver_type)
        formData.append("country", driver[0].country)
        formData.append("weekend", weekend)
        formData.append("location", location)
        formData.append("confirmRequest", false);

        fetch("/api/admin/requestTimeOff",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            setLoading(false);
            if (res.ok) {
                getRequests();
                closeModal(false);
                toast.success("A request has been submitted!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored"
                });
                clearForm();
            } else if (res.status === 400) {
                return res.text();
            }
        }).then((data) => {
            if (data === "You are requesting more days than you have accrued. Do you still want to submit the request?") {
                setRequestData(formData);
                setConfirmationModalVisible(true);
            } else if (data) {
                setErrors([data]);
            }
        }).catch((error) => {
            setErrors(["An error occurred. Please try again."]);
        })
    }

    function confirmRequest() {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        requestData.set("confirmRequest", true);

        fetch("/api/admin/requestTimeOff",
            {
                headers: myHeaders,
                method: 'POST',
                body: requestData
            }
        ).then((res) => {
            setLoading(false);
            if (res.ok) {
                getRequests();
                closeModal(false);
                toast.success("A request has been submitted!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored"
                });
                clearForm();
            } else if (res.status === 400) {
                return res.text();
            }
        }).then((data) => {
            if (data) {
                setErrors([data]);
            }
        }).catch((error) => {
            setErrors(["An error occurred. Please try again."]);
        })
        setConfirmationModalVisible(false);
    }


    function validateData() {
        var errors = []

        var startTime = document.getElementById("startTime") ? document.getElementById("startTime").value : null;
        var endTime = document.getElementById("endTime") ? document.getElementById("endTime").value : null;

        // null checks
        if (type === null) {
            errors.push("Time off type is requred")
        } else if (startDate === null || endDate === null) {
            errors.push("Start and end date are required")
        } else if (halfDay === true && (startTime === null || endTime === null)) {
            errors.push("Start and end time are required when requesting a half day")
        }

        if (errors.length > 0) {
            return errors
        }

        // data validation
        if (startDate > endDate) {
            errors.push("End date must be the same or after start date")
        } else if (startDate.toDateString() !== endDate.toDateString() && halfDay === true) {
            errors.push("Start and end date must be the same to take a half day")
        } else if (halfDay === true && (startTime === "" || endTime === "")) {
            errors.push("Start and end time are required for half day")
        } else if (halfDay === true) {
            if (!getTimeDifference(document.getElementById("startTime").value, document.getElementById("endTime").value)) {
                errors.push("Start and end times must be exactly 4 hours apart")
            }
        }

        return errors

    }

    function getTimeDifference(time1, time2) {
        const parseTime = time => {
            const [hours, minutes, ampm] = time.split(/[:\s]/);
            return { hours: parseInt(hours, 10), minutes: parseInt(minutes, 10), ampm };
        };

        const { hours: hours1, minutes: minutes1, ampm: ampm1 } = parseTime(time1);
        const { hours: hours2, minutes: minutes2, ampm: ampm2 } = parseTime(time2);

        // Convert times to 24-hour format for easier calculation
        const convertTo24HourFormat = ({ hours, ampm }) => {
            if (ampm.toLowerCase() === 'pm' && hours !== 12) {
                return hours + 12;
            } else if (ampm.toLowerCase() === 'am' && hours === 12) {
                return 0;
            }
            return hours;
        };

        const timeInMinutes1 = convertTo24HourFormat({ hours: hours1, ampm: ampm1 }) * 60 + minutes1;
        const timeInMinutes2 = convertTo24HourFormat({ hours: hours2, ampm: ampm2 }) * 60 + minutes2;

        // Calculate time difference in minutes
        const timeDifferenceInMinutes = Math.abs(timeInMinutes2 - timeInMinutes1);

        // Convert minutes to hours and remaining minutes
        const hoursDifference = Math.floor(timeDifferenceInMinutes / 60);
        const minutesDifference = timeDifferenceInMinutes % 60;

        return (hoursDifference === 4 && minutesDifference === 0)
    }

    function addTime(date, time) {
        var t1 = time.split(" ")
        var ampm = t1[1] === "am" ? 0 : 12
        var HoursMins = t1[0].split(":")
        var hours = parseInt(HoursMins[0]) + ampm
        var mins = parseInt(HoursMins[1])

        var newDate = date.setHours(hours, mins)

        return new Date(newDate)
    }

    function clearForm() {
        setStartDate(null)
        setEndDate(null)
        setHalfDay(false)
        setComments("")
        setLocation("")
    }

    useEffect(() => {
        if ((startDate === null || endDate === null) ? false : startDate.toDateString() !== endDate.toDateString()) {
            setHalfDay(false)
        }
        if (startDate > endDate) {
            setEndDate(startDate)
        }
    }, [startDate, endDate])

    useEffect(() => {
        if (type === "TOUNP") {
            setWeekend(false)
        }

    }, [type])

    return (
        <CModal alignment='center' visible={visible} backdrop="static" onClose={() => closeModal(false)} size='xl'>
            <CModalHeader><CModalTitle id="VerticallyCenteredExample">Create New Request</CModalTitle></CModalHeader>
            <CModalBody>
                <CCol >
                    <CRow>
                        <CCol sm="12" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Select Time Off Type</CCardText>
                            <CFormSelect onChange={(e) => { setType(e.target.value) }}>
                                {Object.keys(timeOffNames[driver[0].driver_type][driver[0].country]).map((x, i) => {
                                    return <option key={i} value={x}>{timeOffNames[driver[0].driver_type][driver[0].country][x]}</option>
                                })}
                            </CFormSelect>
                        </CCol>
                        <CCol sm="6" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Start Date</CCardText>
                            {/* Start Date */}
                            <DatePicker
                                id='date-picker'
                                className='form-control'
                                value={startDate}
                                onChange={(date) => { setStartDate(date) }}
                                locale='en-ca'
                                format='yy-MM-dd'
                                minDetail='year'
                                yearPlaceholder='yyyy'
                                monthPlaceholder='mm'
                                dayPlaceholder='dd'
                            />
                        </CCol>
                        <CCol sm="6" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>End Date</CCardText>
                            {/* End Date */}
                            <DatePicker
                                id='date-picker'
                                className='form-control'
                                value={endDate}
                                onChange={(date) => { setEndDate(date) }}
                                locale='en-ca'
                                format='yy-MM-dd'
                                minDetail='year'
                                yearPlaceholder='yyyy'
                                monthPlaceholder='mm'
                                dayPlaceholder='dd'
                                minDate={startDate ? startDate : null}
                            />
                        </CCol>
                        <CCol sm="3" className="my-2">
                            {/* Half Day */}
                            <CFormCheck className='fs-4' label="Half Day" checked={halfDay} onChange={(e) => { setHalfDay(e.target.checked) }} disabled={(startDate === null || endDate === null) ? false : startDate.toDateString() !== endDate.toDateString() || type === "TOSIC" || type === "TOPER"} />
                            <CCardText><i>*must be exactly 4 hours long</i> </CCardText>
                        </CCol>
                        {halfDay ?
                            <>
                                <CCol sm="3">
                                    <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Start Time</CCardText>
                                    <TimePicker
                                        id="startTime"
                                        showSecond={false}
                                        minuteStep={15}
                                        use12Hours={true}
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>End Time</CCardText>
                                    <TimePicker
                                        id="endTime"
                                        showSecond={false}
                                        minuteStep={15}
                                        use12Hours={true}
                                    />
                                </CCol>
                            </>
                            : <CCol sm="6" />}
                        <CCol sm="12" className="my-2">
                            <CFormCheck className='fs-4' label="Include Weekends" checked={weekend} onChange={(e) => { setWeekend(e.target.checked) }} disabled={(type === "TOUNP") ? true : false} />
                        </CCol>
                            <CCol sm="4" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '0px', marginTop: '8px' }}>Start Location of Vacation (optional) </CCardText>
                                <br />
                                <CFormInput className='fs-4' placeholder='Start Location' value={location} onChange={(e) => { if (e.target.value.length <= 100) { setLocation(e.target.value) } }} />
                            </CCol>
                        <CCol sm="12" className="my-2">
                            <CCardText className='fs-4' style={{ marginBottom: '0px', marginTop: '8px' }}>Comments (optional) </CCardText>
                            <CCardText><i>*maximum 200 characters</i> </CCardText>
                            {/* Comments */}
                            <CFormTextarea className='fs-4' placeholder='Comments' value={comments} onChange={(e) => { if (e.target.value.length <= 200) { setComments(e.target.value) } }} />
                        </CCol>
                        <CCol sm="12">
                            <CButton onClick={onSubmit} disabled={loading}>Submit</CButton>
                        </CCol>
                        {errors.length !== 0 ?
                            <CCol sm="12">
                                {errors.map((error, i) => {
                                    return <CCardText key={i} style={{ color: 'red', fontWeight: '600', fontSize: '20px' }}>{error}</CCardText>
                                })}
                            </CCol> : null}
                    </CRow>
                </CCol>
            </CModalBody>
            <CModal visible={confirmationModalVisible} alignment='center' onClose={() => setConfirmationModalVisible(false)}>
                <CModalHeader style={{ backgroundColor: 'black', color: 'white' }}><CModalTitle>Time off Request Confirmation</CModalTitle></CModalHeader>
                <CModalBody style={{ backgroundColor: 'black', color: 'white' }}>
                    <p>You are requesting more days than you have accrued. Do you still want to submit the time off request?</p>
                </CModalBody>
                <CModalFooter style={{ backgroundColor: 'black', color: 'white' }}>
                    <CButton color="dark" variant='outline' onClick={() => setConfirmationModalVisible(false)}>No</CButton>
                    <CButton color="primary" onClick={() => { confirmRequest() }}>Yes</CButton>
                </CModalFooter>
            </CModal>
        </CModal>
    )
}